import React, { FunctionComponent, useContext, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { PostCodeContext } from '../../react/PostCodeContext';
import useGetPostCode from '../../react/useGetPostCode';
import postcodeLabelStyles from './postcodeLabelStyles';
import Translation from '../translation/Translation';

const PostcodeLabel: FunctionComponent = () => {
  const styles = postcodeLabelStyles();

  const postcode = useGetPostCode();

  const displayModalInit: Record<string, boolean> = {
    shouldOpen: true,
    displayCloseIcon: true,
  };

  const { openModal } = useContext(PostCodeContext);

  const displayModal = useCallback(
    (
      openModal: (shouldOpen: boolean, displayCloseIcon?: boolean) => void,
      shouldOpen: boolean,
      displayCloseIcon: boolean,
    ) => {
      openModal(shouldOpen, displayCloseIcon);
    },
    [displayModalInit],
  );

  return (
    <>
      {postcode && (
        <Grid container={true} justifyContent={'center'} className={styles.labelContainer}>
          <Typography data-test={'label:postcode:label'} variant="subtitle1">
            <Translation id={'spc.postcode.label'} values={{ postcode }} />
          </Typography>
          <Typography
            className={styles.change}
            onClick={() => displayModal(openModal, displayModalInit.shouldOpen, displayModalInit.displayCloseIcon)}
            data-test={'button:postcode:change'}
            variant="subtitle1"
          >
            <Translation id={'spc.postcode.change'} />
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default PostcodeLabel;
